const baseUrl =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_ENDPOINT
    : process.env.REACT_APP_API_DEV;

function buildApiPath(path: string): string {
  return `${baseUrl}/api/v1/${path}`;
}

function builPath(path: string): string {
  return `${baseUrl}/${path}`;
}

function buildApiPathV2(path: string): string {
  return `${baseUrl}/api/v2/${path}`;
}

function buildApiPathV3(path: string): string {
  return `${baseUrl}/api/v3/${path}`;
}

function buildApiPathV4(path: string): string {
  return `${baseUrl}/api/v4/${path}`;
}

function buildApiStatic(path: string): string {
  return `${baseUrl}/static/${path}`;
}

const ApiPath = {
  // Auth
  LOGIN: buildApiPath("auth/login"),
  PROFILE: buildApiPath("user/user_info"),
  SETTING: buildApiPath("setting"),

  FORGOTPASSWORD: buildApiPath("auth/forgot_password"),
  VERIFYOTP: buildApiPath("auth/verify_otp"),
  RESETPASSWORD: buildApiPath("auth/reset_password"),
  USERNOTI: buildApiPath("notification/notification_messages"),
  CHANGEPASS: buildApiPath("auth/change_password"),
  RESETPASS: buildApiPath("auth/admin_reset_password"),

  // SIMPUBLIC
  GETSIMPUBLIC: buildApiPathV2("sims/special"),
  IMPORTSIMPUBLIC: buildApiPathV2("sims/import_for_special_store"),

  // SimKitPick
  GETSIMKITPICK: buildApiPathV2("sim-kit-pick/available"),
  SIMKITPICKINIT: buildApiPathV2("sim-kit-pick/init"),
  SIMKITPICKPAC: buildApiPathV2("sim-kit-pick/transactions/{id}/pick-package"),

  SIMKITPICKCART: buildApiPathV2("sim-kit-pick/transactions"),

  SIMKITPICKREGISTER: buildApiPathV2("sim-kit-pick/transactions/{id}/register"),
  SIMKITPICKPAY: buildApiPathV2("sim-kit-pick/transactions/{id}/pay"),
  SIMKITPICKTRANSFER: buildApiPathV2("sim-kit-pick/transactions/{id}/transfer"),
  SIMKITPICKDETAIL: buildApiPathV2("sim-kit-pick/transactions/{id}"),

  //SimNegoRequest
  SIMKITPICKNEGO: buildApiPath("sim_negotiation_request"),
  UPDATESIMDEPOSIT: buildApiPath("sim_negotiation_request/{id}"),
  SIMDEPOSIT: buildApiPathV2("sim-kit-pick/transactions/{id}/deposit"),
  HISNEO: buildApiPathV2("sim-kit-pick/transactions/{id}/negotiations"),

  //NiceSim
  GETNICESIM: buildApiPathV2("sim-kit-pick/nice_sim_available"),

  // SIM
  GETSIM: buildApiPath("sims"),
  SIMIMPORT: buildApiPath("sims/import"),

  SIMFAGENTLOW: buildApiPathV2("sims/transfer_file_sim"),
  SIMFLOW: buildApiPathV2("sims/simflow/import"),

  OTP: buildApiPath("sims/simflow/request-otp"),
  CONFIRMOTP: buildApiPath("sims/simflow/confirm"),
  SIMTEMPLATE: buildApiStatic("templates/mau_nhap_kho_so.xlsx"),
  SIMHAND: buildApiStatic("templates/mau_ban_giao_kho_so.xlsx"),
  SIMREFUND: buildApiStatic("templates/mau_thu_hoi_kho_so.xlsx"),
  SIMEXPORT: buildApiPath("sims/export"),
  SIMTRANFER: buildApiPathV2("sims/transfer_sim"),

  // SIM Embryo
  GETSIMEMBRYO: buildApiPath("sim-base"),

  SIMBASEIMPORT: buildApiPath("sim-base/flow/import"),
  SIMBASEFLOW: buildApiPath("sim-base/flow/transfer/request"),
  SIMBASEOTP: buildApiPath("sim-base/flow/transfer/confirm"),

  SIMBASEEXPORT: buildApiPath("sim-base/export"),

  // Package
  GETPAC: buildApiPathV3("plans"),
  CREATEPAC: buildApiPathV3("plans"),
  UPDATEPAC: buildApiPathV3("plans/{id}"),

  // Client
  GETCLIENT: builPath("profiles"),

  // ĐKTTB
  GETDKTTB: buildApiPath("sim-kit"),
  SKAVAILABLE: buildApiPath("sim-kit/flow/available"),
  PLANSAVAILABLE: buildApiPath("sim-kit/flow/plans/available"),
  BULK: buildApiPath("sim-kit/flow/register/bulk"),

  SKINITDETAIL: buildApiPathV4("sim-kit/flow/register/transactions/{id}"),
  SKRESGISTERDETAIL: buildApiPathV4("sim-kit/flow/register/transactions/{id}"),

  SKINIT: buildApiPathV3("sim-kit/flow/register/init"),
  SKOCR: buildApiPathV3("sim-kit/flow/register/ocr"),
  SKCOMFIRM: buildApiPathV3("sim-kit/flow/register/confirm"),

  SKRESGISTER: buildApiPath("sim-kit/flow/register/transactions"),
  EXPORTDKTTB: buildApiPath("sim-kit/flow/register/transactions/export"),
  DKTTTBTEMPLATE: buildApiStatic("templates/mau_dktttb_log.zip"),
  LOGS: buildApiPath("sim-kit/flow/register/transactions/{id}/logs"),

  // Gán gói
  PLANASS: buildApiPath("sim-kit/flow/plan-assignment/transactions"),
  PLANASSBULK: buildApiPath("sim-kit/flow/plan-assignment/bulk"),
  PLANASSTEMPLATE: buildApiStatic("templates/mau_gan_goi.xlsx"),
  PLANREPORT: buildApiPath("sim-kit/flow/plan-assignment/transactions/export"),

  // User
  GETUSER: buildApiPath("user"),
  CREATEUSER: buildApiPath("user"),
  USERDETAIL: buildApiPath("user/{id}"),
  USERSYSTEM: buildApiPathV2("user/list_roles"),

  //Mer
  MERSUMMARY: buildApiPath("agency/summary"),

  //agency
  AGENCY: buildApiPathV2("agency/get_agency_by_level"),
  DELETEDISCOUNT: buildApiPath("discount/delete_personal_discount"),

  //Wallet
  WALLET: buildApiPath("wallet/history"),

  //Admin Agency
  ADMINMER: buildApiPathV2("agency/agency_admin"),
  CREATEADMER: buildApiPathV2("agency/agency_admin"),
  DETAILADMER: buildApiPathV2("agency/{id}/agency_admin"),

  MER: buildApiPathV2("agency/agency_user"),
  CREATEMER: buildApiPathV2("agency/agency_user"),
  UPDATEMER: buildApiPathV2("agency/{id}/agency_user"),
  UPDATESTATUSMER: buildApiPathV2("agency/{id}/set_status_agency_user"),

  //Trans
  TRANS: buildApiPath("transactions"),
  TRANSREPORT: buildApiPath("transactions/export"),
  TRANSDETAIL: buildApiPath("transactions/{id}"),

  //Limit
  LIMIT: buildApiPath("wallet/requests"),
  CREATELIMIT: buildApiPath("wallet/requests/init"),
  CONFIRMLIMIT: buildApiPath("wallet/requests/{id}/confirm"),
  UPDATELIMIT: buildApiPath("wallet/requests/{id}"),
  LIMITDETAIL: buildApiPath("wallet/requests/{id}"),
  LIMITREPORT: buildApiPath("wallet/requests/export"),
  REFUND: buildApiPath("wallet/add_balance"),

  //Rose
  ROSE: buildApiPath("commission-payouts"),
  ROSEINIT: buildApiPath("commission-payouts"),
  ROSEDOWN: buildApiPath("commission-payouts/{id}/download"),

  // Commission statements
  COMMISSIONIMPORT: buildApiPath("commission-import-batches/import"),
  COMMISSIONAGENCIES: buildApiPath("commission-import-batches/agencies"),
  COMMISSIONSTATEMENT: buildApiPath("commission-statements/{id}"),
  COMMISSIONSTATUS: buildApiPath("commission-statements/{id}/status"),

  //profile
  WALLETS: buildApiPath("user/{id}/wallets/{walletID}"),

  //topup
  GETTOPUP: buildApiPathV2("top_up"),
  CREATETOPUP: buildApiPathV2("top_up"),
  UPDATETOPUP: buildApiPathV2("top_up/{id}"),
  TOPUPINIT: buildApiPathV3("top_up/recharge_topup_init"),
  TOPUPCONFIRM: buildApiPathV2("top_up/recharge_topup_confirm"),

  //card
  GETCARD: buildApiPathV2("mobile_card"),
  CREATECARD: buildApiPathV2("mobile_card"),
  UPDATECARD: buildApiPathV2("mobile_card/{id}"),
  CARDINIT: buildApiPathV3("mobile_card/recharge_mobile_card_init"),
  CARDCONFIRM: buildApiPathV2("mobile_card/recharge_mobile_card_confirm"),
  DATADETAIL: buildApiPath("transactions/{id}"),

  //Data
  GETDATA: buildApiPathV2("data"),
  GETDATAUNIT: buildApiPathV2("data/get_by_duration_unit"),
  CREATEDATA: buildApiPathV2("data"),
  UPDATEDATA: buildApiPathV2("data/{id}"),
  DATAINIT: buildApiPathV3("data/recharge_mobile_data_init"),

  DATACONFIRM: buildApiPathV2("data/recharge_mobile_data_confirm"),

  //Discount
  GETDISCOUNT: buildApiPathV2("discount/get_user_product_discount"),
  UPDATEDISCOUNT: buildApiPath("discount/set_user_product_discount"),

  //location
  PROVINCES: buildApiPath("location/provinces"),
  DISTRICTS: buildApiPath("location/districts/{id}"),
  WARDS: buildApiPath("location/wards/{id}"),

  USERDISCOUNT: buildApiPath("discount/groups/set"),
  DKTTBDISCOUNT: buildApiPath("discount-transactions/default"),
  DKTTBDIS: buildApiPath("discount-transactions"),

  //setting maintenance order
  SETTING_STATUS_MAINTENANCE_ORDER: buildApiPath("setting/status-maintenance-order"),
  SETTING_GET_MAINTENANCE_FEATURES: buildApiPath("setting/maintenance/features"),
  SETTING_UPDATE_MAINTENANCE_FEATURE: (id: string) => buildApiPath(`setting/system-maintenance/${id}`),
};

export default ApiPath;
